define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var VisitMonitoring = require('web-agent-assets-js/lpVisitMonitoring');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var lpSdeDataHandler = require('web-agent-assets-js/lpSdeDataHandler');

    lpTag.lpVisitMonitoringController = function (model, config) {
        this.applicationType = "lpVisitMonitoringController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var getVisitorProfile, visitorProfileContext, getVisitorBehavior, visitorBehaviorContext, getLob, lobContext, getGoal, goalContext, getCampaign, campaignContext, getEngagement, engagementContext, getWindow, windowContext;
        if (config) {
            getVisitorProfile = config.getVisitorProfile;
            visitorProfileContext = config.visitorProfileContext;
            getVisitorBehavior = config.getVisitorBehavior;
            visitorBehaviorContext = config.visitorBehaviorContext;
            getGoal = config.getGoal;
            goalContext = config.goalContext;
            getEngagement = config.getEngagement;
            engagementContext = config.engagementContext;
            getCampaign = config.getCampaign;
            campaignContext = config.campaignContext;
            getWindow = config.getWindow;
            windowContext = config.windowContext;
            getLob = config.getLob;
            lobContext = config.lobContext;
        }

        var visitMonitoringApi;

        this.getMonitoringData = function (data) {
            getMonitoringData(data);
        };

        initializeApi();

        function initializeApi() {
            visitMonitoringApi = new VisitMonitoring();
        }

        /////////////////////////////// SHARK DATA ///////////////////////////////////

        function getMonitoringData(data) {
            logger.info("","getMonitoringData", data);
            var visitorId, sessionId;
            if (data) {
                visitorId = data.visitorId;
                sessionId = data.sessionId;
            }
            if (visitorId && sessionId) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleMonitoringDataSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleMonitoringDataError, data),
                    context: data
                };
                visitMonitoringApi.getVisitorData(requestObj, visitorId, sessionId);
            }
        }

        function handleMonitoringDataSuccess(data) {
            logger.info("MonitoringData return as Success", "handleMonitoringDataSuccess");
            var dataToUse = [];
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            if (data && data.body && data.body.appSessions) {
                dataToUse = data.body.appSessions;
            }
            if (dataToUse && dataToUse.length) {
                for (var index = 0; index < dataToUse.length; index++) {
                    if (dataToUse[index] && !dataToUse[index].visitorId) {
                        if (dataObject && dataObject.data && dataObject.data.visitorId) {
                            dataToUse[index].visitorId = dataObject.data.visitorId;
                        }
                        var processedItem = getSingleMonitoringObject(dataToUse[index], dataObject, context);
                        lpTag.lpVisitMonitoringController.prototype.addDataObjectToVisitorInfo(model, processedItem, lpTag.lpVisitMonitoringController.prototype.serviceNames.visitMonitoring, dataObject);
                    }
                }
            }
        }

        function handleMonitoringDataError(data) {
            logger.warn("", "handleMonitoringDataError", data);
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            var obj = {
                visitorId: context.visitorId
            };
            var processedItem = getSingleMonitoringObject(obj, dataObject, context);
            lpTag.lpVisitMonitoringController.prototype.addDataObjectToVisitorInfo(model, processedItem, lpTag.lpVisitMonitoringController.prototype.serviceNames.visitMonitoring, dataObject, 'error');
        }

        function getSingleMonitoringObject(monitoringObject, dataObject, context) {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(monitoringObject.visitorId);
            var modelPath = participantPath + ".participantInfo";
            var modelData = model.get(modelPath);
            if (!modelData) {
                modelPath = "participants.visitorList.data." + monitoringObject.visitorId + ".participantInfo";
                modelData = model.get(modelPath);
            }
            var toReturn = lpTag.lpVisitMonitoringController.prototype.createCommonInfoDataObject(modelData, monitoringObject.visitorId);
            engagementsDataHandler(monitoringObject, toReturn, dataObject, context);
            for (var property in monitoringObject) {
                if (monitoringObject.hasOwnProperty(property)) {
                    switch (property) {
                        case 'engagements':
                            handleEngagementsArray(monitoringObject[property], toReturn, dataObject);
                            break;
                        case 'geo':
                            toReturn.country = monitoringObject[property].country;
                            toReturn.countryCode = monitoringObject[property].countryCode;
                            toReturn.geoState = monitoringObject[property].state;
                            toReturn.geoCity = monitoringObject[property].city;
                            toReturn.organization = monitoringObject[property].org;
                            toReturn.isp = monitoringObject[property].isp;
                            break;
                        case 'events':
                            lpSdeDataHandler.handleEvents(monitoringObject[property], toReturn, monitoringObject);
                            break;
                        case 'id':
                            toReturn.sessionId = monitoringObject[property];
                            break;
                        case 'deviceOS':
                            if (!toReturn.operatingSystem) {
                                toReturn.operatingSystem = monitoringObject[property];
                            }
                            break;
                        case 'deviceOSDetails':
                            toReturn.operatingSystem = monitoringObject[property].name;
                            if (monitoringObject[property].version) {
                                toReturn.operatingSystem += ' ' + monitoringObject[property].version;
                            }
                            break;
                        case 'pages':
                            toReturn.pages = lpTag.lpVisitMonitoringController.prototype.handlePages(monitoringObject[property], pageTransformer);
                            monitoringObject.pages = null;
                            delete monitoringObject.pages;
                            break;
                        case 'userAgentDetails':
                            if (monitoringObject[property].type === 'Browser') {
                                toReturn.browser = monitoringObject[property].name;
                                if (monitoringObject[property].version) {
                                    toReturn.browser += ' ' + monitoringObject[property].version;
                                }
                            }
                            break;
                        //case 'revActiveVPs':
                        //case 'revAllVPs':
                        //case 'revActiveVBs':
                        //case 'revAllVBs':
                        //case 'revActiveOSLs':
                        //case 'revAllOSLs':
                        case 'externalReferrer':
                        case 'ipv4':
                        case 'ipv6':
                        case 'startTime':
                        case 'browserCookiePolicyType':
                        case 'siteControlGroup':
                        case 'returningVisitor':
                        case 'searchEngine':
                        case 'mobileDeviceInfo':
                        case 'userAgent':
                        case 'deviceFamily':
                        case 'visitorId':
                            toReturn[property] = monitoringObject[property];
                            break;
                    }
                }
            }
            if (toReturn.chatStartPageId && toReturn.pages) {
                for (var pageIndex = 0; pageIndex < toReturn.pages.length; pageIndex++) {
                    if (toReturn.pages[pageIndex] && toReturn.pages[pageIndex].id && toReturn.pages[pageIndex].id === toReturn.chatStartPageId) {
                        toReturn.chatStartUrl = toReturn.pages[pageIndex].url;
                        break;
                    }
                }
            }
            return toReturn;
        }

        function pageTransformer(page) {

            var url, title, sections, startTime;
            if (page.hasOwnProperty("pageBasic") && page.pageBasic && typeof page.pageBasic === "object") {
                url = page.pageBasic.url;
                title = page.pageBasic.title;
                startTime = page.pageBasic.startTime;
                sections = page.pageBasic.sections;
            }

            return {
                url: url,
                title: title,
                sections: sections,
                startTime: startTime
            };
        }

        function engagementsDataHandler(monitoringObject, toReturn, dataObject, context) {
            // If we have the engagement ID & campaign ID from the App Server - we use them directly instead of looking for them in the engagements array
            var engagementId = model.get(lpTag.WebAgent.logicController.getParticipantPath(monitoringObject.visitorId) + '.participantInfo.engagementId');
            var campaignId = model.get(lpTag.WebAgent.logicController.getParticipantPath(monitoringObject.visitorId) + '.participantInfo.campaignId');
            getCampaignById(campaignId, toReturn, dataObject);
            getEngagementById(engagementId, toReturn, dataObject, campaignId, context);
        }

        function getCampaignById(campaignId, toReturn, dataObject) {
            if (campaignId && toReturn && getCampaign) {
                var campaignModelData = getSingleModelItemById(campaignId, lpTag.lpVisitMonitoringController.prototype.serviceNames.campaigns, getCampaign, campaignContext, toReturn.visitorId, dataObject);
                toReturn.campaign = campaignModelData;
                // If we found the ID - we add the campaign object to the "toReturn" collection
                var lobId = campaignModelData.lobId;
                if (lobId) {
                    if (!lobContext) {
                        lobContext = {};
                    }
                    var lobModelData = getSingleModelItemById(lobId, lpTag.lpVisitMonitoringController.prototype.serviceNames.lob, getLob, lobContext, toReturn.visitorId, dataObject);
                    toReturn.lob = lobModelData;
                }
            }
        }

        function getEngagementById(engagementId, toReturn, dataObject, campaignId, context) {
            if (engagementId && toReturn && getEngagement) {
                var isNewChat = !!context && !!context.isNewChat;
                if (!engagementContext) {
                    engagementContext = {};
                }
                if (campaignId) {
                    engagementContext.campId = campaignId;
                }
                // If it's a new chat - we forcefully re-request the engagement and window-conf to make sure we have the correct survey
                var engagementModelData = getSingleModelItemById(engagementId, lpTag.lpVisitMonitoringController.prototype.serviceNames.engagements, getEngagement, engagementContext, toReturn.visitorId, dataObject, isNewChat);
                toReturn.engagement = engagementModelData;
                // If we found the ID - we add the engagement object to the "toReturn" collection
                var windowId = engagementModelData.windowId;
                if (windowId) {
                    if (!windowContext) {
                        windowContext = {};
                    }
                    // If it's a new chat - we forcefully re-request the engagement and window-conf to make sure we have the correct survey
                    var windowModelData = getSingleModelItemById(windowId, lpTag.lpVisitMonitoringController.prototype.serviceNames.window, getWindow, windowContext, toReturn.visitorId, dataObject, isNewChat);
                    toReturn.window = windowModelData;
                }
            }
        }

        function getSingleModelItemById(id, serviceName, sendRequestCallback, sendRequestContext, visitorId, dataObject, forceRefresh) {
            var modelData = model.get(serviceName + '.data.' + id);
            if (!modelData || forceRefresh) {
                if (visitorId) {
                    lpTag.lpVisitMonitoringController.prototype.addServiceToRequestedServices(serviceName, dataObject, model);
                    sendRequestCallback.call(sendRequestContext, {id: id, visitorId: visitorId, dataObject: dataObject});
                } else {
                    sendRequestCallback.call(sendRequestContext, {id: id});
                }
                modelData = {id: id};
            }
            return modelData;
        }

        function getModelItemsByIds(data, serviceName, sendRequestCallback, sendRequestContext, visitorId, dataObject) {
            var tempData = [];
            if (data) {
                for (var id in data) {
                    if (data.hasOwnProperty(id)) {
                        tempData.push(getSingleModelItemById(id, serviceName, sendRequestCallback, sendRequestContext, visitorId, dataObject));
                    }
                }
            }
            return tempData;
        }

        function handleActiveVisitorProfile(data, collection, dataObject) {
            if (data && collection && getVisitorProfile) {
                var modelData = getModelItemsByIds(data, lpTag.lpVisitMonitoringController.prototype.serviceNames.visitorProfile, getVisitorProfile, visitorProfileContext, collection.visitorId, dataObject);
                collection.visitorProfile = modelData;
            }
        }

        function handleActiveVisitorBehavior(data, collection, dataObject) {
            if (data && collection && getVisitorBehavior) {
                var modelData = getModelItemsByIds(data, lpTag.lpVisitMonitoringController.prototype.serviceNames.visitorBehavior, getVisitorBehavior, visitorBehaviorContext, collection.visitorId, dataObject);
                collection.visitorBehavior = modelData;
            }
        }

        function handleLobEntity(entity, collection, dataObject) {
            if (entity && entity.id && collection && getLob) {
                var modelData = getSingleModelItemById(entity.id, lpTag.lpVisitMonitoringController.prototype.serviceNames.lob, getLob, lobContext, collection.visitorId, dataObject);
                collection.lob = modelData;
            }
        }

        function handleEngagementsArray(engagements, collection, dataObject) {
            var engagementData;
            var mostRecentEngagement = getMostRecentEngagement(engagements);
            if (mostRecentEngagement && mostRecentEngagement.engagement) {
                engagementData = mostRecentEngagement.engagement;
                if (engagementData) {
                    handleCampaignEntity(engagementData.campaignEntity, collection, dataObject);
                    handleEngagementEntity(engagementData.campaignEntity, engagementData.engagementEntity, collection, dataObject);
                    handleGoalEntity(engagementData.goalEntity, collection, dataObject);
                }
            }
            if (mostRecentEngagement && mostRecentEngagement.impressionAccepted) {
                var impression = mostRecentEngagement.impressionAccepted;
                var time, pageId;
                if (mostRecentEngagement.impressionAccepted === Array) {
                    for (var index = 0; index < mostRecentEngagement.impressionAccepted.length; index++) {
                        impression = mostRecentEngagement.impressionAccepted[index];
                        if (impression.activityTime) {
                            time = impression.activityTime;
                        }
                        if (impression.pageId) {
                            pageId = impression.pageId;
                        }
                    }
                }
                if (impression.activityTime) {
                    time = impression.activityTime;
                }
                if (impression.pageId) {
                    pageId = impression.pageId;
                }
                if (time) {
                    collection.chatRequestedTime = time;
                }
                if (pageId) {
                    collection.chatStartPageId = pageId;
                }
            }
        }

        function handleCampaignEntity(entity, collection, dataObject) {
            if (entity) {
                // We only try to get the campaign if we didn't already put it in the collection according to the ID from the app server
                if (entity.id && collection && getCampaign && !collection.campaign) {
                    getCampaignById(entity.id, collection, dataObject);
                }
                if (entity.activeVPs) {
                    handleActiveVisitorProfile(entity.activeVPs, collection, dataObject);
                }
            }
        }

        function handleEngagementEntity(campaignEntity, engagementEntity, collection, dataObject) {
            if (engagementEntity) {
                if (engagementEntity.type) {
                    // here we need to also get the text path for the given engagement type.
                    // for instance LECampaigns.engagementDetailsView.type.toaster.text
                    if (collection) {
                        collection.engagementType = engagementEntity.type;
                    }
                }
                // We only try to get the engagement if we didn't already put it in the collection according to the ID from the app server
                if (engagementEntity.id && collection && getEngagement && !collection.engagement) {
                    getEngagementById(engagementEntity.id, collection, dataObject, campaignEntity && campaignEntity.id);
                }
                if (engagementEntity.activeVBs) {
                    handleActiveVisitorBehavior(engagementEntity.activeVBs, collection, dataObject);
                }
            }
        }

        function handleGoalEntity(entity, collection, dataObject) {
            if (entity && entity.id && collection && getGoal) {
                var modelData = getSingleModelItemById(entity.id, lpTag.lpVisitMonitoringController.prototype.serviceNames.goals, getGoal, goalContext, collection.visitorId, dataObject);
                collection.goal = modelData;
            }
        }

        function getMostRecentEngagement(engagements) {
            var mostRecentEngagement = null;
            if (engagements && engagements.length) {
                for (var engagement = 0; engagement < engagements.length; engagement++) {
                    if (!mostRecentEngagement) {
                        mostRecentEngagement = engagements[engagement];
                    } else {
                        var currentEngagementTime = getTimeOfEngagement(engagements[engagement]);
                        var savedEngagementTime = getTimeOfEngagement(mostRecentEngagement);
                        if (currentEngagementTime && (!savedEngagementTime || currentEngagementTime > savedEngagementTime)) {
                            mostRecentEngagement = engagements[engagement];
                        }
                    }
                }
            }
            return mostRecentEngagement;
        }

        function getTimeOfEngagement(engagement) {
            var time = null;
            if (engagement && engagement.impressionAccepted) {
                var impression = engagement.impressionAccepted;
                if (impression && impression.activityTime) {
                    time = impression.activityTime;
                } else if (impression && impression.length) {
                    for (var index = 0; index < impression.length; index++) {
                        if (impression[index] && impression[index].activityTime) {
                            time = impression[index].activityTime;
                        }
                    }
                }
            }
            return time;
        }
    };
    lpTag.lpVisitMonitoringController.prototype = new lpBaseInfoController();

    return lpTag.lpVisitMonitoringController;

});
